export const ApplicantDetailsPage = {
  firstNameLabel: 'First name',
  middleNameLabel: 'Middle name (if applicable)',
  lastNameLabel: 'Last name',
  whoIsYourEmployerLabel: 'Who is your employer? (if applicable)',
  emailAddressLabel: 'Email address',
  mobileNumberLabel: 'Mobile number',
  secondaryContactNumberLabel: 'Secondary contact number (optional)',
};
